<template>
  <div id="app">
    <Header></Header>
    <div class="content-box">
      <router-view />
    </div>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.content-box{
  min-height: 624px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue